import { Injectable } from '@angular/core';
import swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';

@Injectable()
export class PopupMessageService {
  position = 'top-right'
  title: string;
  msg: string;
  showClose = true;
  timeout = 5000;
  theme = 'bootstrap';
  type = 'default';
  closeOther = false;

  constructor(private toastyService: ToastyService) {

  }

  openBasicSwal(title, text) {
    swal
      ({
        title: title,
        text: text
      }).catch(swal.noop);
  }

  openSuccessSwal(title, text) {
    swal({
      type: 'success',
      title: title,
      text: text
    }).catch(swal.noop);
  }
  openWarningSwal(title, text) {
    swal({
      type: 'warning',
      title: title,
      text: text
    }).catch(swal.noop);
  }
  openErrorSwal(title, text) {
    swal({
      type: 'error',
      title: title,
      text: text
    }).catch(swal.noop);
  }


  openConfirmsSwal() {
    let isDelete: any;

    isDelete = swal
      ({
        title: 'Are you sure?',
        text: 'You want be able to revert',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(result => {
        if (result.value == true) {
          this.openSuccessSwal('Deleted', 'Record deleted successfully')
        }
      })

    return isDelete;
  }

  openWarningWithoutButtonSwal(title, text) {
    swal({
      type: 'warning',
      title: title,
      text: text,
      showCancelButton: false,
      showConfirmButton: false,
      backdrop:false,
      customClass: 'swal-wide'
    }).catch(swal.noop);
  }

  addToast(options) {
    if (options.closeOther) {
      this.toastyService.clearAll();
    }
    this.position = options.position ? options.position : this.position;
    const toastOptions: ToastOptions = {
      title: options.title,
      msg: options.msg,
      showClose: options.showClose,
      timeout: options.timeout,
      theme: options.theme,
      onAdd: (toast: ToastData) => {
        console.log('Toast ' + toast.id + ' has been added!');
      },
      onRemove: (toast: ToastData) => {
        console.log('Toast ' + toast.id + ' has been added removed!');
      }

    };

    this.toastyService.success(toastOptions);

  }


}



// WEBPACK FOOTER //
// ./src/app/service/popupMessageService.ts